import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
document.addEventListener("DOMContentLoaded", function () {
    const netflixSlider = document.querySelector(".netflix-slider");
    const netflixSlideCount = netflixSlider ? netflixSlider.querySelectorAll('.swiper-slide').length : 0;

    const netflixSwiper = new Swiper(".netflix-slider", {
        slidesPerView: netflixSlideCount > 1 ? 1.10 : 1,
        watchSlidesProgress: true,
        spaceBetween: 16,
        breakpoints: {
            640: { spaceBetween: 24, slidesPerView: 2 },
            992: { spaceBetween: 24, slidesPerView: 2 },
            1280: { spaceBetween: 24, slidesPerView: 3 },
        },
        navigation: {
            nextEl: '.netflix-right',
            prevEl: '.netflix-left',
        },
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const readSlider = document.querySelector(".read-slider");
    const readSlideCount = readSlider ? readSlider.querySelectorAll('.swiper-slide').length : 0;

    const readSwiper = new Swiper(".read-slider", {
        slidesPerView: readSlideCount > 1 ? 1.10 : 1,
        watchSlidesProgress: true,
        spaceBetween: 16,
        breakpoints: {
            640: { spaceBetween: 24, slidesPerView: 2 },
            992: { spaceBetween: 24, slidesPerView: 2 },
            1280: { spaceBetween: 24, slidesPerView: 3 },
        },
        navigation: {
            nextEl: '.read-right',
            prevEl: '.read-left',
        },
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const gallerySlider = document.querySelector(".gallery-slider");
    const gallerySlideCount = gallerySlider ? gallerySlider.querySelectorAll('.swiper-slide').length : 0;

    const gallerySwiper = new Swiper(".gallery-slider", {
        slidesPerView: gallerySlideCount > 1 ? 1.1 : 1,
        watchSlidesProgress: true,
        initialSlide:1,
        spaceBetween: 8,
        breakpoints: {
            640: { spaceBetween: 8 },
            992: { spaceBetween: 16 },
            1280: { spaceBetween: 24 },
        },
        navigation: {
            nextEl: '.gallery-right',
            prevEl: '.gallery-left',
        },
    });
});